import api from "@/helpers/api";
import type { WidgetConfig } from "../types/widget";

export const getWidgetConfig = async () => {
  const response = await api.get({ path: "/widgets" });
  return response;
};

export const saveWidgetConfig = async (config: WidgetConfig) => {
  const response = await api.post({ path: "/widgets", data: config });
  return response;
};
